import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type MemberSurvey } from "./types";

export default {
  init: (
    apiInfo: ModuleApiInfo,
    args: MemberSurvey.Api.InitRequest
  ): Promise<HttpApiResponse<MemberSurvey.Api.InitResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/member/survey`, args),

  createAnswer: (
    apiInfo: ModuleApiInfo,
    args: MemberSurvey.Api.CreateUpdateUserFeedbackRequest
  ): Promise<HttpApiResponse<MemberSurvey.Api.CreateUserFeedbackResponse>> =>
    api.post(apiInfo, `/api/site/v1/modules/member/survey`, args),

  updateAnswer: (
    apiInfo: ModuleApiInfo,
    args: MemberSurvey.Api.UpdateUserFeedbackRequest
  ): Promise<HttpApiResponse<MemberSurvey.Api.UpdateUserFeedbackResponse>> =>
    api.put(apiInfo, `/api/site/v1/modules/member/survey`, args)
};
